import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-payment',
    templateUrl: './payment.component.html',
    styleUrls: ['./payment.component.css'],
    standalone: false
})
export class PaymentComponent implements OnInit {
  paymentOpt = 1;
  color = [1, 0, 0, 0]

  constructor() { }

  ngOnInit(): void {
  }

  change(num) {
    this.paymentOpt=num;
    this.color[0] = 0;
    this.color[1] = 0;
    this.color[2] = 0;
    this.color[3] = 0;
    this.color[num-1] = 1;
  } 

}
